<template>
  <div :class="{ 'danger-scale': true, 'danger-scale--responsive': responsive }">
    <div class="danger-scale__wrapper danger-scale__wrapper--large">
      <p class="danger-scale__text danger-scale__text--title">Avalanche danger scale:</p>
      <svg
        class="danger-scale__scale"
        viewBox="0 0 594 41"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          transform="translate(-25.000000, -848.000000)"
        >
          <g transform="translate(-13.000000, 799.000000)">
            <g transform="translate(29.000000, 13.000000)">
              <g>
                <text font-family="Gibson-Regular, Gibson" font-size="12.1" font-weight="normal" fill="#4A4A4A">
                  <tspan x="11" y="73.6">No Rating</tspan>
                </text>
                <text font-family="Gibson-Regular, Gibson" font-size="12.1" font-weight="normal" fill="#4A4A4A">
                  <tspan x="117.7" y="73.6">Low</tspan>
                </text>
                <text font-family="Gibson-Regular, Gibson" font-size="12.1" font-weight="normal" fill="#4A4A4A">
                  <tspan x="212.3" y="73.6">Moderate</tspan>
                </text>
                <text font-family="Gibson-Regular, Gibson" font-size="12.1" font-weight="normal" fill="#4A4A4A">
                  <tspan x="306.9" y="73.6">Considerable</tspan>
                </text>
                <text font-family="Gibson-Regular, Gibson" font-size="12.1" font-weight="normal" fill="#4A4A4A">
                  <tspan x="403.7" y="73.6">High</tspan>
                </text>
                <text font-family="Gibson-Regular, Gibson" font-size="12.1" font-weight="normal" fill="#4A4A4A">
                  <tspan x="499.4" y="73.6">Extreme</tspan>
                </text>
                <rect fill="#D8D8D8" fill-rule="evenodd" x="14.3" y="41.8" width="95.7" height="8.8"></rect>
                <rect fill="#54BB51" fill-rule="evenodd" x="124.3" y="41.8" width="95.7" height="8.8"></rect>
                <rect fill="#FFF41F" fill-rule="evenodd" x="220" y="41.8" width="95.7" height="8.8"></rect>
                <rect fill="#F8972C" fill-rule="evenodd" x="315.7" y="41.8" width="95.7" height="8.8"></rect>
                <rect fill="#EF2B2F" fill-rule="evenodd" x="411.4" y="41.8" width="95.7" height="8.8"></rect>
                <rect fill="#000000" fill-rule="evenodd" x="507.1" y="41.8" width="95.7" height="8.8"></rect>
                <rect fill="#F8972C" fill-rule="evenodd" x="306.9" y="36.3" width="18.7" height="18.7"></rect>
                <rect fill="#FFF41F" fill-rule="evenodd" x="211.2" y="36.3" width="18.7" height="18.7"></rect>
                <rect fill="#54BB51" fill-rule="evenodd" x="117.7" y="36.3" width="18.7" height="18.7"></rect>
                <rect fill="#EF2B2F" fill-rule="evenodd" x="402.6" y="36.3" width="18.7" height="18.7"></rect>
                <rect fill="#000000" fill-rule="evenodd" x="498.3" y="36.3" width="18.7" height="18.7"></rect>
                <text font-size="10.89" font-weight="500" fill="#FFFFFF">
                  <tspan x="124.50174" y="49.5">1</tspan>
                </text>
                <text font-size="10.89" font-weight="500" fill="#606060">
                  <tspan x="217.14143" y="49.5">2</tspan>
                </text>
                <text font-size="10.89" font-weight="500" fill="#FFFFFF">
                  <tspan x="312.84143" y="49.5">3</tspan>
                </text>
                <text font-size="10.89" font-weight="500" fill="#FFFFFF">
                  <tspan x="408.54143" y="49.5">4</tspan>
                </text>
                <text font-size="10.89" font-weight="500" fill="#FFFFFF">
                  <tspan x="504.24143" y="49.5">5</tspan>
                </text>
                <rect fill="#D9D9D9" fill-rule="evenodd" x="9.9" y="36.3" width="17.6" height="17.6"></rect>
                <text font-size="10.89" font-weight="500" fill="#FFFFFF">
                  <tspan x="14.74143" y="49.5">0</tspan>
                </text>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <p class="danger-scale__text d-inline-block hide-print">
        <a class="link" href="#" @click.prevent="showDangerScale = true">
          <i class="fa fa-question-circle mr-1"></i>What is this?
        </a>
      </p>
    </div>
    <div v-if="responsive" class="danger-scale__wrapper danger-scale__wrapper--small">
      <svg
        width="323px"
        height="94px"
        viewBox="0 0 323 94"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-15.000000, -1954.000000)">
            <g transform="translate(15.000000, 1954.000000)">
              <text font-family="Gibson-Regular, Gibson" font-size="16" font-weight="normal" fill="#4A4A4A">
                <tspan x="232" y="86">Extreme</tspan>
              </text>
              <rect fill="#000000" fill-rule="evenodd" x="191" y="66" width="26.9292035" height="26.9384615"></rect>
              <text font-size="15.6816" font-weight="500" fill="#FFFFFF">
                <tspan x="199.556261" y="85">5</tspan>
              </text>
              <text font-family="Gibson-Regular, Gibson" font-size="16" font-weight="normal" fill="#4A4A4A">
                <tspan x="41.1858407" y="17.5846154">No Rating</tspan>
              </text>
              <text font-family="Gibson-Regular, Gibson" font-size="16" font-weight="normal" fill="#4A4A4A">
                <tspan x="41.1858407" y="52.2769231">Low</tspan>
              </text>
              <text font-family="Gibson-Regular, Gibson" font-size="16" font-weight="normal" fill="#4A4A4A">
                <tspan x="41.1858407" y="85.1384615">Moderate</tspan>
              </text>
              <text font-family="Gibson-Regular, Gibson" font-size="16" font-weight="normal" fill="#4A4A4A">
                <tspan x="232" y="19">Considerable</tspan>
              </text>
              <text font-family="Gibson-Regular, Gibson" font-size="16" font-weight="normal" fill="#4A4A4A">
                <tspan x="232" y="52">High</tspan>
              </text>
              <rect fill="#F8972C" fill-rule="evenodd" x="191" y="0" width="26.9292035" height="26.9384615"></rect>
              <rect
                fill="#FFF41F"
                fill-rule="evenodd"
                x="0"
                y="66.5538462"
                width="26.9292035"
                height="26.9384615"
              ></rect>
              <rect
                fill="#54BB51"
                fill-rule="evenodd"
                x="0"
                y="33.2769231"
                width="26.9292035"
                height="26.9384615"
              ></rect>
              <rect fill="#EF2B2F" fill-rule="evenodd" x="191" y="33" width="26.9292035" height="26.9384615"></rect>
              <text font-size="15.6816" font-weight="500" fill="#FFFFFF">
                <tspan x="9.79510737" y="52.4461538">1</tspan>
              </text>
              <text font-size="15.6816" font-weight="500" fill="#606060">
                <tspan x="8.55626097" y="85.7230769">2</tspan>
              </text>
              <text font-size="15.6816" font-weight="500" fill="#FFFFFF">
                <tspan x="199.556261" y="19">3</tspan>
              </text>
              <text font-size="15.6816" font-weight="500" fill="#FFFFFF">
                <tspan x="199.556261" y="52">4</tspan>
              </text>
              <rect fill="#D9D9D9" fill-rule="evenodd" x="0" y="0" width="26.9292035" height="26.9384615"></rect>
              <text font-size="15.6816" font-weight="500" fill="#FFFFFF">
                <tspan x="8.55626097" y="19.1692308">0</tspan>
              </text>
            </g>
          </g>
        </g>
      </svg>
      <p class="danger-scale__text mt-3 hide-print">
        <a class="link" href="#" @click.prevent="showDangerScale = true">
          <i class="fa fa-question-circle mr-1"></i>What is this?
        </a>
      </p>
    </div>
    <modal v-if="showDangerScale" @close="showDangerScale = false">
      <img src="/resources/themes/default/images/avalanche-danger-scale.jpg" alt="Danger scale description" />
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    responsive: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      showDangerScale: false
    };
  }
};
</script>
